import { render, staticRenderFns } from "./organization-bulk-invite.vue?vue&type=template&id=28a4636a&"
import script from "./organization-bulk-invite.vue?vue&type=script&lang=js&"
export * from "./organization-bulk-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports